<template>
  <el-container>
    <el-aside width="140px" style="background-color:#c1c1c1">
      <search-bar @search="search" />
    </el-aside>
    <el-container>
      <el-main class="main">
        <keep-alive include="customer-company-list">
          <router-view :params="params" />
        </keep-alive>
      </el-main>
      <el-footer class="footer no-print">&copy;2018 Cystron Technology Limited</el-footer>
    </el-container>
  </el-container>
</template>

<script>
import SearchBar from './SearchBar.vue'
export default {
  components: {
    SearchBar
  },
  data () {
    return {
      params: {}
    }
  },
  methods: {
    search (params) {
      this.params = params
      this.$router.push('/customer/company')
    }
  }
}
</script>

<style>
.main {
  background: #F7F7F7;
  padding-top: 10px;
  padding: 10px;
}
.el-table td,.el-table th {
  padding: 4px 0 !important;
}
.el-table .el-button--text {
  padding-top: 0px;
  padding-bottom: 0px;
}
.row-green {
  color: #008B00;
}
.row-red {
  color: #ff0000;
}
.row-bg-green {
  background-color: #008B00;
}
.row-bg-red {
  background-color: #ff0000;
}
.el-pagination {
  margin-top: 4px;
}
.footer {
  font-size: 14px;
  border-top: 1px solid #D9DEE4;
  background: #fff;
  height: 40px !important;
  line-height: 40px;
  color: #999;
  text-align: right;
}
</style>
